import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RemoveselComponent } from './removesel.component';
import { RouterModule } from '@angular/router';
import { SaveStateData } from 'dbweb-core';

@NgModule({
	declarations: [RemoveselComponent],
	imports: [
		CommonModule,
		RouterModule.forChild([
			{
				path: '**',
				component: RemoveselComponent,
				data: SaveStateData
			}
		])
	]
})
export class RemoveselModule {}
